import { useTheme } from '@mui/material/styles';
import { createAppTheme } from './theme';
type AppTheme = ReturnType<typeof createAppTheme>;

export function useAppTheme() {
  return useTheme<AppTheme>();
}
